import { Alert } from '@designsforhealth/dfh-react-components'
import React from 'react'

import { withAuthenticationRequiredOrAnonymousCart } from '../../../../hoc/withAuthenticationRequiredOrAnonymousCart'
import Head from '../../../../layouts/Head'
import { isMagentoScopeNotGrantedError } from '../../../../lib/auth/errors'
import { useCartContext } from '../../../../lib/cart'
import { useCartRebateValidation } from '../../../../lib/cart/hooks/useCartRebateValidation'
import ErrorAccessingMagentoMessage from '../../../ErrorAccessingMagentoMessage'
import ErrorRetrievingDataMessage from '../../../ErrorRetrievingDataMessage'
import Layout from '../../../global/Layout'
import Spinner from '../../../Spinner'
import BuyGlobalStyle from '../../layout/BuyGlobalStyle'
import CartContainer from '../CartContainer'
import * as Styled from './styled'

export const CartPage: React.VFC = withAuthenticationRequiredOrAnonymousCart(() => {
  const { cart, loading: cartLoading, error } = useCartContext()

  const { loading: rebateValidationLoading } = useCartRebateValidation()

  return (
    <>
      <Head />
      <BuyGlobalStyle />
      <Layout fullWidth showFooter={false}>
        <Styled.Wrapper>
          <Styled.Content>
            {rebateValidationLoading || cartLoading ? (
              <Spinner loading />
            ) : !cart ? (
              <Alert type="error">
                {isMagentoScopeNotGrantedError(error) ? (
                  <ErrorAccessingMagentoMessage />
                ) : (
                  <ErrorRetrievingDataMessage />
                )}
              </Alert>
            ) : (
              <CartContainer />
            )}
          </Styled.Content>
        </Styled.Wrapper>
      </Layout>
    </>
  )
})
